import config from '../../config';

const URLS = {};

const FLOWS = {};

const langPrefix = lang => (lang ? `/${lang}` : '');

const platformUrl = (path, lang) => `${config.platformUrl}${langPrefix(lang)}${path}`;

const thankYouUrl = (subscriptionId, lang) =>
    platformUrl(`/subscription/${subscriptionId}/thank-you?is_upsell=true`, lang);
const thankYouNoUpsellUrl = (subscriptionId, lang) => platformUrl(`/subscription/${subscriptionId}/thank-you?is_upsell=false`, lang);
const dashboardUrl = lang => platformUrl('/dashboard', lang);

const stepUrl = (step, subscriptionId, lang) =>
    `${langPrefix(lang)}${URLS[step.id]}?subscriptionId=${subscriptionId}`;

const getNextUrl = ({ next, subscriptionId, lang }) => {
    if (!subscriptionId) return dashboardUrl(lang);

    return next ? stepUrl(next, subscriptionId, lang) : thankYouUrl(subscriptionId, lang);
};

const resolveStep = ({ prelander, id, subscriptionId, conditions = {} }) => {
    const flow = FLOWS[prelander];
    const steps = flow?.steps?.(conditions) ?? [];
    const idx = steps.findIndex(s => s.id === id);
    const current = steps[idx];
    const next = idx === -1 ? undefined : steps[idx + 1];

    return {
        ui: current?.ui ?? {},
        withSuccessModal: current?.withSuccessModal === true,
        nextUrl: getNextUrl({ next, subscriptionId, lang: flow?.lang })
    };
};

const resolveFirstStepUrl = (prelander, subscriptionId, conditions = {}) => {
    const flow = FLOWS[prelander];
    const [first] = flow?.steps?.(conditions) ?? [];

    if (!first) return thankYouNoUpsellUrl(subscriptionId, flow?.lang);

    return getNextUrl({ next: first, subscriptionId, lang: flow.lang });
};

export {
    resolveStep,
    resolveFirstStepUrl
};
